/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Models_Default_HelpInputs */



/**
* | output |
* | --- |
* | "This model is used by default when members of this team start new chats, unless overridden elsewhere." |
*
* @param {Team_Models_Default_HelpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const team_models_default_help = /** @type {((inputs?: Team_Models_Default_HelpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Models_Default_HelpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieses Modell wird standardmäßig verwendet, wenn Mitglieder dieses Teams neue Chats starten, sofern es nicht an anderer Stelle überschrieben wird.")
	return /** @type {LocalizedString} */ ("This model is used by default when members of this team start new chats, unless overridden elsewhere.")
});